import { resolveImagePath } from '@/utils/imageMap';

export function DiscoveryFlight() {
  const discoveryFlightBgUrl = resolveImagePath('/images/discovery-flight-bg.jpg');

  return (
    <section 
      className="relative min-h-[500px] bg-cover bg-center bg-no-repeat flex items-center"
      style={{ backgroundImage: `url(${discoveryFlightBgUrl})` }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          {/* Discovery Flight Content */}
          <div className="space-y-6">
            {/* Headline */}
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Tour our Academy and Schedule a Discovery Flight Today!
              </h2>
            </div>
            
            {/* Description */}
            <div>
              <p className="text-lg md:text-xl text-white font-light leading-relaxed">
                We offer a 30-minute Discovery Flight for $129.99 so that you can experience an introductory flight lesson at a discounted rate.
              </p>
            </div>
            
            {/* CTA Button */}
            <div>
              <a
                href="/contact-us"
                className="inline-flex items-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-colors duration-200"
              >
                <span>Take a Tour</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}